<div class="request-location-bubble-container">
    {{content?.locationRequest | json}}
  @if (content?.locationRequest?.text) {
    <div class="message-container">
      <div class="header-text">{{ content?.locationRequest?.text }}</div>
      <div class="body-text">{{ content?.locationRequest?.body }}</div>
    </div>
  } @else {
    <div class="message-container">
      @if (content?.locationRequest?.src) {
        <img class="header-img" src="{{ content?.locationRequest?.src }}" alt=""/>
      } @else {
        <div class="header-text"></div>
      }
      <div class="body-text">{{ content?.locationRequest?.body }}</div>
    </div>
  }
  <div class="divider"></div>
  <div class="send-location" (click)="sendLocationClick($event)">
    <div class="location-icon"></div>
    <div class="text-lbl">Send Location</div>
  </div>
</div>



